{
  "id": "bmw",
  "sources": "BMW parts-catalogue main groups in plain workshop wording: the first two digits of a BMW part number.",
  "groups": [
    { "number": "07", "name": { "en": "Bolts and Nuts", "de": "Schrauben und Muttern" } },
    { "number": "11", "name": { "en": "Engine", "de": "Motor" } },
    { "number": "12", "name": { "en": "Engine Electrical System", "de": "Motorelektrik" } },
    {
      "number": "13",
      "name": { "en": "Intake and Fuel Injection", "de": "Ansaugung und Einspritzung" }
    },
    { "number": "16", "name": { "en": "Fuel Supply", "de": "Kraftstoffversorgung" } },
    { "number": "17", "name": { "en": "Cooling System", "de": "Kühlung" } },
    { "number": "18", "name": { "en": "Exhaust System", "de": "Abgasanlage" } },
    { "number": "21", "name": { "en": "Clutch", "de": "Kupplung" } },
    {
      "number": "22",
      "name": { "en": "Engine and Transmission Mounts", "de": "Motor- und Getriebeaufhängung" }
    },
    { "number": "23", "name": { "en": "Manual Transmission", "de": "Schaltgetriebe" } },
    { "number": "24", "name": { "en": "Automatic Transmission", "de": "Automatikgetriebe" } },
    { "number": "25", "name": { "en": "Gearshift", "de": "Schaltung" } },
    { "number": "26", "name": { "en": "Drive Shaft", "de": "Gelenkwelle" } },
    { "number": "31", "name": { "en": "Front Axle", "de": "Vorderachse" } },
    { "number": "32", "name": { "en": "Steering", "de": "Lenkung" } },
    { "number": "33", "name": { "en": "Rear Axle", "de": "Hinterachse" } },
    { "number": "34", "name": { "en": "Brakes", "de": "Bremsen" } },
    { "number": "35", "name": { "en": "Pedals", "de": "Pedale" } },
    { "number": "36", "name": { "en": "Wheels", "de": "Räder" } },
    { "number": "41", "name": { "en": "Bodywork", "de": "Karosserie" } },
    { "number": "51", "name": { "en": "Vehicle Trim", "de": "Fahrzeugausstattung" } },
    { "number": "52", "name": { "en": "Seats", "de": "Sitze" } },
    {
      "number": "54",
      "name": { "en": "Sliding Roof / Folding Top", "de": "Schiebedach / Faltverdeck" }
    },
    { "number": "61", "name": { "en": "Vehicle Electrical System", "de": "Fahrzeugelektrik" } },
    {
      "number": "62",
      "name": { "en": "Instruments and Gauges", "de": "Instrumente und Anzeigen" }
    },
    { "number": "63", "name": { "en": "Lighting", "de": "Beleuchtung" } },
    {
      "number": "64",
      "name": { "en": "Heating and Air Conditioning", "de": "Heizung und Klimaanlage" }
    },
    {
      "number": "65",
      "name": {
        "en": "Audio, Navigation, Electronic Systems",
        "de": "Audio, Navigation, Elektroniksysteme"
      }
    },
    {
      "number": "66",
      "name": { "en": "Distance Systems, Cruise Control", "de": "Abstandssysteme, Tempomat" }
    },
    {
      "number": "71",
      "name": { "en": "Onboard Tools and Equipment", "de": "Bordwerkzeug und Ausrüstung" }
    },
    { "number": "72", "name": { "en": "Seat Belts and Airbags", "de": "Gurte und Airbags" } },
    { "number": "82", "name": { "en": "Accessories", "de": "Zubehör" } },
    { "number": "83", "name": { "en": "Fluids", "de": "Betriebsstoffe" } },
    { "number": "84", "name": { "en": "Communication Systems", "de": "Kommunikationssysteme" } }
  ]
}
